const namespace='DIALOGS'

export const ON_DIALOG_OPEN_CHANGED = `${namespace}@ON_DIALOG_OPEN_CHANGED`;



// WEBPACK FOOTER //
// ./src/store/dialogs/types.js